(() => {
  const mobile = window.matchMedia('(max-width: 989px)');
  const categories = [
    ['e-bikes', 'E-bikes'],
    ['e-scooter', 'E-scooter'],
    ['accessories', 'Accessories'],
    ['service', 'Service'],
  ];
  const shortLabels = {
    'app-control-9-inch-electric-scooter': 'ASAP 9 E-Scooter',
    'asap-10-v1-electric-scooter': 'ASAP 10 V1 E-Scooter',
    'asap-10-v2-electric-scooter': 'ASAP 10 V2 E-Scooter',
    'asap-11-electric-scooter': 'ASAP 11 E-Scooter',
  };

  function productCard(source) {
    const href = source.getAttribute('href');
    const sourceImage = source.querySelector('img');
    if (!href || !sourceImage) return null;
    const handle = href.split('/products/')[1]?.split('?')[0];
    const label = shortLabels[handle] || source.textContent.trim();
    const card = document.createElement('a');
    card.className = 'asap-mobile-reference-card';
    card.href = href;
    const image = document.createElement('img');
    const imageUrl = new URL(sourceImage.currentSrc || sourceImage.src, location.href);
    imageUrl.searchParams.set('width', '240');
    image.src = imageUrl.href;
    image.alt = label;
    image.width = 94;
    image.height = 94;
    image.loading = 'lazy';
    const caption = document.createElement('p');
    caption.textContent = label;
    card.append(image, caption);
    return card;
  }

  function buildNavigation(panels) {
    const navigation = document.createElement('nav');
    navigation.className = 'asap-mobile-reference-nav';
    navigation.setAttribute('aria-label', 'Main menu');
    for (const [key, label] of categories) {
      const source = panels.get(key);
      const category = document.createElement('details');
      category.className = 'asap-mobile-reference-category';
      const toggle = document.createElement('summary');
      toggle.className = 'asap-mobile-reference-toggle';
      toggle.textContent = label;
      category.appendChild(toggle);
      if (key === 'service') {
        const content = document.createElement('div');
        content.className = 'asap-mobile-reference-service';
        for (const sourceGroup of source.querySelectorAll('.asap-four-service > div')) {
          const sourceHeading = sourceGroup.querySelector('h3');
          if (!sourceHeading) continue;
          const group = document.createElement('section');
          const heading = document.createElement('h3');
          heading.textContent = sourceHeading.textContent.trim();
          group.appendChild(heading);
          for (const sourceLink of sourceGroup.querySelectorAll('a')) {
            const link = document.createElement('a');
            link.href = sourceLink.getAttribute('href');
            link.textContent = sourceLink.textContent.trim();
            if (sourceLink.target === '_blank') {
              link.target = '_blank';
              link.rel = 'noopener noreferrer';
            }
            group.appendChild(link);
          }
          content.appendChild(group);
        }
        category.appendChild(content);
      } else {
        const grid = document.createElement('div');
        grid.className = 'asap-mobile-reference-grid';
        for (const sourceLink of source.querySelectorAll('.asap-four-menu__products a')) {
          const card = productCard(sourceLink);
          if (card) grid.appendChild(card);
        }
        category.appendChild(grid);
      }
      navigation.appendChild(category);
    }
    return navigation;
  }

  function enhanceMobileMenu() {
    if (!mobile.matches) return false;
    const drawer = document.querySelector('header-drawer .menu-drawer');
    const panels = new Map([...document.querySelectorAll('.asap-four-menu')].map((panel) => [panel.dataset.asapFourPanel, panel]));
    if (!drawer || categories.some(([key]) => !panels.has(key))) return false;
    if (categories.slice(0, 3).some(([key]) => !panels.get(key).querySelector('.asap-four-menu__products a img'))) return false;
    if (!panels.get('service').querySelector('.asap-four-service h3')) return false;
    drawer.querySelector(':scope > .asap-mobile-menu-brand')?.remove();
    drawer.querySelector(':scope > .asap-mobile-menu-shortcuts')?.remove();
    drawer.classList.remove('asap-mobile-menu-ready');
    if (!drawer.querySelector(':scope > .asap-mobile-reference-nav')) {
      drawer.appendChild(buildNavigation(panels));
    }
    drawer.classList.add('asap-mobile-rider-ready');
    return true;
  }

  let observer = null;
  let timeout = null;
  let scheduled = false;
  function stopWaiting() {
    observer?.disconnect();
    observer = null;
    if (timeout) clearTimeout(timeout);
    timeout = null;
  }
  function ensureMobileMenu() {
    if (!mobile.matches) {
      stopWaiting();
      return;
    }
    enhanceMobileMenu();
    if (!observer) {
      observer = new MutationObserver((records) => {
        const headerChanged = records.some((record) => {
          const element = record.target instanceof Element ? record.target : record.target.parentElement;
          return element?.closest('header-component') || [...record.addedNodes].some((node) =>
            node instanceof Element && (node.matches('header-component') || node.querySelector('header-component'))
          );
        });
        if (!headerChanged || scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          enhanceMobileMenu();
        });
      });
      observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });
    }
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(stopWaiting, 15000);
  }
  function handleMenuInteraction(event) {
    const element = event.target instanceof Element ? event.target : null;
    if (!element) return;
    if (event.type === 'click' && element.closest('header-drawer summary[aria-label="Menu"]')) ensureMobileMenu();
    if (event.type === 'toggle' && element.matches('details.menu-drawer-container') && element.open) ensureMobileMenu();
  }
  function handleMenuEscape(event) {
    if (event.key !== 'Escape' || !mobile.matches) return;
    const container = document.querySelector('header-drawer details.menu-drawer-container');
    if (!container?.open) return;
    const close = container.querySelector('.menu-drawer > .menu-drawer__close-button');
    if (close) {
      event.preventDefault();
      close.click();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureMobileMenu, { once: true });
  } else {
    ensureMobileMenu();
  }
  document.addEventListener('shopify:section:load', ensureMobileMenu);
  document.addEventListener('click', handleMenuInteraction, true);
  document.addEventListener('toggle', handleMenuInteraction, true);
  document.addEventListener('keydown', handleMenuEscape, true);
  mobile.addEventListener('change', ensureMobileMenu);
})();
